export default __webpack_public_path__ + "static/gw2-icon-events-8f7f138c1bc7c681213bdcf1f8398331.png";